export default __webpack_public_path__ + "static/media/gate.2ffa5e9d.webp";